import styled from "styled-components"
import CurrentLocationButton from "../CurrentLocationButton"

export const Container = styled.div`
  height: 100%;
  position: relative;
`

export const StyledCurrentLocationButton = styled(CurrentLocationButton)`
  position: absolute;
  top: 20px;
  left: 20px;
`
